<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .confirmation-header {
    display: flex;
    gap: utils.in_rem(12px);
    padding: utils.in_rem(8px) 0;

    img {
      width: utils.in_rem(30px);
      height: utils.in_rem(30px);
    }

    span {
      @include mixins.h2();
    }
  }

  .confirmation-body {
    margin: 0 utils.in_rem(24px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: utils.in_rem(24px);
    gap: utils.in_rem(16px);
    border-top: 1px solid colors.get("interfaceSwGrey_10");
    @include mixins.h3();
    height: utils.in_rem(224px);
  }

  .cta-wrapper {
    margin: 0 utils.in_rem(24px);
    padding: utils.in_rem(12px) 0;
    align-self: stretch;
    align-items: center;
    border-top: 1px solid colors.get("interfaceSwGrey_10");
    flex-shrink: 0;
    .confirmation-button {
      display: flex;
      justify-content: right;
    }
  }
</style>

<script>
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import Icon from "@sourcewhale/shared/svelte-design-system/components/atoms/Icon.svelte";
  import Modal from "@sourcewhale/shared/svelte-design-system/components/molecules/Modal/Modal.svelte";
  import { toUtilityClasses } from "@sourcewhale/shared/svelte-design-system/components/tokens/utils";
  import { showRegisterInterestModal } from "./stores";

  const color = "interfaceSwGrey_20";

  const onclose = () => {
    $showRegisterInterestModal = false;
  };
</script>

<Modal {onclose} size="small">
  <div class="confirmation-header" slot="header">
    <img src="/assets/img/logo/svg/icon-dark-blue.svg" alt="BrandMark" />
    <span>Confirmation</span>
  </div>
  <div class="confirmation-body">
    <Icon class="fas fa-whale {toUtilityClasses({ color })}" size="xl" />
    <span>Request Sent!</span>
  </div>
  <div class="cta-wrapper">
    <div class="confirmation-button">
      <Button kind="primary" size="small" onclick={onclose}>Close</Button>
    </div>
  </div>
</Modal>
